import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const lambdaOption: Option<CriteriaKey> = {
  name: 'AWS Lambda',
  description:
    'A serverless, event-driven compute service that lets you run code for virtually any type of application or backend service without provisioning or managing servers.',
  tags: ['Serverless', 'FaaS'],
  pros: ['Scalable', 'Cons-effective', 'Ease of use', 'Event-driven'],
  cons: [
    'Cold starts',
    'Limited concurrency',
    'Limited memory',
    'Execution timeout',
  ],
  documentationLink: 'https://aws.amazon.com/lambda/',
  criteriaScores: {
    asyncExecution: { score: { value: 10 } },
    scalability: { score: { value: 10 } },
    unlimitedExecutionTimeout: { score: { value: 1 } },
    storagePersistance: { score: { value: 1 } },
    vendorLockIn: { score: { value: 1 } },
    containerizationLimitations: { score: { value: 5 } },
    operationalManagement: { score: { value: 2 } },
    etlOriented: { score: { value: 5 } },
    batchingProcessing: { score: { value: 3 } },
  },
};
